<template>
	<ul class="article-listings">
		<li v-for="entry in entries" :key="entry.id" class="listing">
			<slot name="listing" :entry="entry"></slot>
		</li>
	</ul>
</template>

<script>
	export default {
		name: "articleListings",
		props: {
			entries: {
				type: Array
			}
		}
	}
</script>

<style lang="scss" scoped>

	@import "container.scss";
	@import "list-style-reset.scss";
	@import "responsive-font";
	@import "media";

	.article-listings {
		@include responsive-font(10);
		@include list-style-reset;
		display:flex; flex-wrap:wrap; margin:3em -3em;
	}

	.listing {
		margin-top:3em; border:3em solid transparent; position:relative; flex-basis:100%;
		@include media(large) {
			flex:0 0 33.3333%;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/ArticleListings.vue